import { useEffect, useState, useCallback, useMemo, useRef, createRef } from 'react';
import { Container, Gridtit, Titulo, Biggrid, CicloAtual, CiclosAntigos, Thumb, IniText, PositButtons, Nociclos } from './styles';
import { ListaALunos } from '../Header/styles';
import { Buttons } from '../Aside/styles';
import { Diasciclo } from '../Diasciclo';
import Ciclo from '../Ciclo';
import { useAuth } from '../../hooks/Auth';
import Loading from '../../components/Loading';
import {api} from '../../services/api';
import Modal from '../../components/Modal';
import { Link, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import useCurrentWidth from '../../hooks/useCurrentwidth';
import { format, parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

interface DataDash {
    aluno? : any
}

const Dash: React.FC<DataDash> = ({aluno}) => {

    const location = useLocation();
    const splt = location.pathname.split('/');
    const page = splt[1];
    

    const userlogado = useAuth();
    const user = useMemo(() => aluno ? {...aluno} : userlogado.user, [aluno, userlogado.user]);

    const [load, setLoad] = useState(true);
    const [numdias, setNumdias] = useState(1); // total de didas do maior ciclo
    const [idciclos, setIdCiclos] = useState([]); // numeros id dos ciclos
    const [totalciclos, setTotoalciclos] = useState(0); // total de ciclos
    const [highlight, sethighlight] = useState<number>(0);
    const scrollRef = useRef<HTMLInputElement>(null);
    const cicloRef = useRef([]);
    const [showmodal, setShowmodal] = useState(false);
    const [datamodal, setDatamodal] = useState({});    
    const [updateCiclo, setUpdateciclo] = useState(false);
    const [disabledarrow, setDisabledarrow] = useState(false);
    const [erroapi, setErroapi] = useState(false);

    const [ dispCicloAtual, setDispCicloAtual ] = useState(true);
    const [ dispOldsCiclos, setDispOldsCiclos ] = useState(true);

    const [regra, setRegra] = useState([]);
    const [openRegra, setOpenRegra] = useState(false);

    const widthWindow = useCurrentWidth();

    const getTotalCiclos = useCallback(async (id: number) => {    
        
        try {
            const params = { iduser : id }  
            
            const resp = await api.get('/ciclos/totalCiclos.php', { params : params });
            
            setIdCiclos(resp.data.data); 
            setTotoalciclos(resp.data.data.length);
            setNumdias(1);
            setLoad(false);

        } catch (err : any) {           
            const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR BUSCAR OS DADOS';
            toast.error(resp);
            setErroapi(true);
        }     
            
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getRegras = useCallback(async (id: number) => {    
        
        try {
            const params = { "iduser" : id }
            const resp = await api.get('/regras/getRegra.php', { params : params });            
            setRegra(resp.data);                
        } catch (err : any) {           
            const resp = err.response.statusText ? err.response.statusText : 'ERRO AO BUSCAR REGRAS';
            toast.error(resp);
        }     
            
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let mounted = true;
        if(mounted){
                          
                getTotalCiclos(user.iduser);               
                getRegras(user.iduser)
        }
        return function cleanup() {
            mounted = false
        }
    }, [getTotalCiclos, getRegras, aluno, user.iduser])

    useEffect(() => {        
        // criando ref e class para fazer o hover trocar de cor na linha toda
        if(idciclos.length > 0){                        
            cicloRef.current = idciclos.map((_, i) => cicloRef.current[i] ?? createRef());
        }          

    }, [idciclos]);

    useEffect(() => {
        if(scrollRef.current){
            scrollRef.current.scrollTo(0, 0); 
        }
        if(widthWindow <= 860){
            setDispOldsCiclos(false);
            setDispCicloAtual(true);
        }        
        if(widthWindow > 860){
            setDispOldsCiclos(true);
            setDispCicloAtual(true);
        }
        
        
    }, [widthWindow])

    const changeNumdias = useCallback((totaldias: number) => {
        setNumdias(prev => totaldias > prev ? totaldias : prev);
    }, []);
    
    function quantColuns(){
        if(widthWindow > 1720){
            return 3;
        }
        if(widthWindow <= 1720 && widthWindow >= 1301){
            return 2;
        }
        if(widthWindow < 1301 && widthWindow > 860){
            return 1;
        }
        if(widthWindow === 0 || widthWindow <= 860){
            return 1;
        }
        return 0
    }

    function scrollToRef(side: string){  
        if(scrollRef.current){         
             
            const quantcolunas = quantColuns();
            if(quantcolunas === 1 && side === 'right' && scrollRef.current.scrollLeft === 0 && dispOldsCiclos === false){                    
                setDispCicloAtual(false);
                setDispOldsCiclos(true);                
            } else if(scrollRef.current.scrollLeft === 0 && side === 'left' && quantcolunas === 1 && dispOldsCiclos === false) {                
                setDispCicloAtual(true);
                setDispOldsCiclos(false);
            } else if(scrollRef.current.scrollLeft === 0 && side === 'left' && quantcolunas === 1 && dispOldsCiclos === false) {                
                setDispCicloAtual(true);
                setDispOldsCiclos(false);
            } if(scrollRef.current.scrollLeft === 0 && side === 'left' && quantcolunas === 1 && dispOldsCiclos === true && dispCicloAtual === false) {                
                setDispCicloAtual(true);
                setDispOldsCiclos(false);
            }
            

            let spaceW = side === 'right' ? 
                scrollRef.current.offsetWidth / quantcolunas + scrollRef.current.scrollLeft :
                scrollRef.current.scrollLeft - scrollRef.current.offsetWidth / quantcolunas; 

            
            scrollRef.current.scrollTo(spaceW, 0);             
            
        }
        setDisabledarrow(true);
        setTimeout(function(){
            setDisabledarrow(false);
        }, 600)

    } 

    /* add novo ciclo */
    function handleNewCiclo(){
        setShowmodal(true);
        const iduser = user.iduser;
        setDatamodal({
            'component': 'add',
            'title': 'Adicionar Novo Ciclo',         
            'id_user' : iduser,
            'numciclo' : 999999,
            'inifimciclo': 1,
        })  
    }

    /* add nova regra */
    function handleNewRegra(){
        setShowmodal(true);
        const iduser = user.iduser;
        setDatamodal({
            'component': 'addregra',
            'title': 'Adicionar Nova Mensagem',         
            'id_user' : iduser
        })  
    }
    /* add nova regra */
    function handleEditRegra(){
        setShowmodal(true);
        const iduser = user.iduser;
        setDatamodal({
            'component': 'editregra',
            'title': 'Editar',         
            'id_user' : iduser,
            'dados' : regra[0]
        })  
    }
  
    return (
        <>
        <Modal show={showmodal} setShowmodal={() => setShowmodal(!showmodal)} datamodal={datamodal} setUpdateciclo={() => setUpdateciclo(!updateCiclo) } />
        
       <PositButtons>
            <Buttons>
                <button disabled={disabledarrow} onClick={() => scrollToRef('right')}><span className="material-icons">chevron_right</span></button>
                <button disabled={disabledarrow} onClick={() => scrollToRef('left')}><span className="material-icons">chevron_left</span></button>
            </Buttons>
            
            {
            user.edit === 'on' || !user.hasOwnProperty('edit') ?
                <button className="newciclo" onClick={() => handleNewCiclo()}><span title="ADICIONAR NOVO CICLO" className="material-icons">more_time</span></button>
            : null
            }
        </PositButtons>        
        <Container>
            <Gridtit>
                {user.thumb_user ? 
                    <Thumb><img src={user.thumb_user} alt={user.nome} /></Thumb> : 
                    <Thumb><div className="nothumb">{user.nome.charAt(0)}</div></Thumb>
                }                
                {userlogado.user.iduser === user.iduser ? (
                    <IniText>
                        <Titulo>Olá <span>{user.nome}</span>, É um prazer ter você aqui!</Titulo>
                        Este é o seu painel de acompanhamento e anotações do Método de Ovulação Billings (MOB). 
                        Este sistema tem como objetivo te ajudar na anotação e acompanhamento do seu 
                        ciclo menstrual. Por este sistema você poderá compartilhar com seu cônjuge ou instrutora 
                        do MOB de forma simples e prática, basta informar o e-mail do seu cônjuge e da sua 
                        instrutora nas configurações do seu <Link to="/perfil">perfil</Link>. 
                        <br /><br />Abaixo listamos todos os ciclos já registrados. Caso queira editar uma 
                        anotação ou símbolo basta clicar sobre. Fique a vontade para nos mandar sugestões e 
                        dúvidas de utilização.
                    </IniText>
                ) : (
                    <IniText>
                        <Titulo>
                        <small>
                        PAINEL DE: <span>{user.nome}</span> <br />
                        {user.nomeconjuge && 'CONJUGÊ: '}
                        <span>{user.nomeconjuge && user.nomeconjuge}</span>
                        </small>
                        </Titulo>
                        <strong>DESEJA ENGRAVIDAR? </strong>{user.desejogravidez === 'on' ? 'SIM' : 'NÃO'}
                        <br />
                        <strong>EMAIL:  </strong>{user.email}

                        <div className="btnsregra">
                            {page === 'alunos' &&
                                <button title="Adicione uma regra do mob para o usuário seguir" onClick={() => handleNewRegra()}>Adicionar mensagem</button>
                            }
                            { regra.length > 0 && 
                                <button title="Veja a lista de regras estabelecidas para este usuário" onClick={() => setOpenRegra(!openRegra)}>Ver Mensagens</button>
                            }
                        </div>
                    </IniText>
                )}

            </Gridtit>
            
            {!load ? ( 
                idciclos.length > 0 ? (          
                <Biggrid>
                    
                    <Diasciclo 
                        numdias={numdias} 
                        hightLight={highlight} 
                    />
                    <CicloAtual dispCiclo={dispCicloAtual}>
                        <Ciclo 
                            user={user}
                            totalciclos={totalciclos} 
                            cicloatual={true} 
                            idciclo={idciclos[0]} 
                            changeNumdias={changeNumdias} 
                            changeHighlight={(e: number) => sethighlight(e)}
                            hightLight={highlight} 
                            setShowmodal={() => setShowmodal(!showmodal)}
                            datamodal={(e:any) => setDatamodal(e)}
                            updateCiclo={updateCiclo}
                            idAllCiclos={idciclos}
                        />
                    </CicloAtual>
                    <CiclosAntigos ref={scrollRef}  dispCiclo={dispOldsCiclos}>
                        {idciclos.map((e: any, i:number) => i > 0 ? (
                            <Ciclo
                                user={user}                                     
                                key={e.numciclo} 
                                i={i} 
                                totalciclos={totalciclos} 
                                idciclo={e} 
                                antigo={true} 
                                changeNumdias={changeNumdias}
                                changeHighlight={(e: number) => sethighlight(e)}
                                hightLight={highlight}   
                                setShowmodal={() => setShowmodal(!showmodal)} 
                                datamodal={(e:any) => setDatamodal(e)}
                                updateCiclo={updateCiclo}  
                                idAllCiclos={idciclos} 
                            />) : (null) )}
                    </CiclosAntigos>
                </Biggrid>
                ) : (
                    <Nociclos>
                        NENHUM CICLO AINDA FOI ADICIONADO.
                        <br /><br />
                        { !erroapi && (
                            user.edit === 'on' || !user.hasOwnProperty('edit')  ?
                            <button onClick={() => handleNewCiclo()}> CLIQUE AQUI PARA ADICIONAR O 1º CICLO </button>
                            : null
                            )
                        }
                        
                    </Nociclos>
                )
            ) : (
                <Loading />
            )}
            


        {!load && regra.length > 0 ? (
            <ListaALunos color={'white'} open={openRegra}>

                <button className="close" onClick={() => setOpenRegra(!openRegra)}><span className="material-icons">close</span></button>

                <h1>MENSAGENS PARA { user.nome }</h1>
                <br />
                <p>
                ABAIXO TEMOS O HISTÓRICO DE INSTRUÇÕES, AVISOS E MENSAGENS ENVIADAS AO USUÁRIO.
                </p>
                <br />
                <div className="scroll">
                    {regra.map((e: any, i: number) => 
                    <div key={`regra`+i} className={i !== 0 ? 'boxregra passado' : 'boxregra'}>
                        <div className="diaregra">
                            <span className="material-icons">calendar_today</span>
                            <span className="dia">{format(parseISO(e.dataupdate), "dd")}</span>
                            <span className="mes">{format(parseISO(e.dataupdate), "MMM", { locale: ptBR})} . {format(parseISO(e.dataupdate), "Y")}</span>

                            {/*i === 0 && <span className="statusregra"><strong>REGRA ATUAL</strong></span> */}
                        </div>
                        <div className="info">
                            
                            <small>INSTRUTORA:</small> {e.nomeinstrutor}
                            <pre>
                            {e.instrucao}
                            </pre>                            
                        </div>
                        
                        {i === 0 && page === 'alunos' && <button onClick={() => handleEditRegra()} className="edit">editar</button> }
                    </div>
                    )}
                </div>                
                <br />
                <div className="bgfixed"></div>
            </ListaALunos>
        ) : null}  
                    <div>Copyright - Todos os direitos reserados - metodobillins.com.br - <a href="https://api.whatsapp.com/send?phone=5533988017451&amp;amp;amp;text=Ol%C3%A1%20gostaria%20de%20falar%20sobre%20o%20APP%20Mob" target="_blank" rel="noreferrer">Fale com o Desenvolvedor</a><br></br>&nbsp;</div>
        </Container>  
        </>
    )
}

export default Dash;